import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DeviceSettingsMethods, { IDeviceSettings } from './deviceSettings.local.methods'
import DeviceSettingsTabs from './__tabs/deviceSettings__tabs'
import DeviceSettingsProxy from './__proxy/deviceSettings__proxy'
import DeviceSettingsAccept from './__accept/deviceSettings__accept'
import DeviceSettingsPinCode from './__pinCode/deviceSettings__pinCode'
import DeviceSettingsSyncContent from './__syncContent/deviceSettings__syncContent'
import DeviceSettingsOnlineOfflineMode from './__onlineOfflineMode/deviceSettings__onlineOfflineMode'
import DeviceSettingsBrowserMode from './__browserMode/deviceSettings__browserMode'
import DeviceSettingsTimer from './__timer/deviceSettings__timer'
import DeviceSettingsVideoPlayer from './__videoPlayer/deviceSettings__videoPlayer'
import DeviceSettingsAndroidVideoPlayer from './__videoPlayer/deviceSettings__androidVideoPlayer'
import DeviceSettingsAudioPlayer from './__audioPlayer/deviceSettings__audioPlayer'
import DeviceSettingsWebEngine from './__webEngine/deviceSettings__webEngine'
import DeviceSettingsBrightnessLegacy from './__brightness_legacy/deviceSettings__brightness'
import DeviceSettingsBrightness from './__brightness/deviceSettings__brightness'
import DeviceSettingsCover from './__cover/deviceSettings__cover'
import DeviceSettingsMegafon from './__megafon/deviceSettings__megafon'
import DeviceSettingsAudioOutput from './__audioOutput/deviceSettings__audioOutput'
import DeviceSettingsKioskMode from './__kioskMode/deviceSettings__kioskMode'
import DeviceSettingsRemoteControl from './__remoteControl/deviceSettings__remoteControl'
import StopBroadcastWhenUpdate from './__stopBroadcastWhenUpdate/deviceSettings__stopBroadcastWhenUpdate'
import DeviceSettingsLogLevel from './__logLevel/deviceSettings__logLevel'
import DeviceSettingsSystemNotifications from './__systemNotifications/deviceSettings__systemNotifications'
import DeviceSettingsContentStorage from './__contentStorage/deviceSettings__contentStorage'
import DeviceSettingsLowBatteryWarning from './__lowBatteryWarning/deviceSettings__lowBatteryWarning'
import DeviceSettingsNoSettings from './__noSettings/deviceSettings__noSettings'
import DeviceSettingsPictureMode from './__pictureMode/deviceSettings__pictureMode'
import DeviceSettingsExhibitionMode from './__exhibitionMode/deviceSettings__exhibitionMode'
import RestartMediaStream from './__restartMediaStream/deviceSettings__restartMediaStream'
import DeviceSettingsWebRTC from './__webRTC/deviceSettings__webRTC'
import { DeviceSettingsFilePath } from './__filePath/deviceSettings__filePath'
import Collapse from 'blocks.simple/collapse/collapse'
import Colorpicker from 'blocks.simple/colorpicker/colorpicker'
import EditText from 'blocks.simple/editText/editText'
import { Button } from 'molecules/Button'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import { Radio } from 'atoms/Radio'
import { cn } from 'ethcss'
import translate from 'core/translate'
import { text as textStyles } from 'theme'
import item from 'blocks.simple/item/item.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import styles from './deviceSettings.jcss'
import { Typography } from 'atoms/Typography'
import { isExist, isNotEmptyArray } from '../../core/utils/coreUtil'
import { DeviceSettingsDownloadMode } from './DeviceSettingsDownloadMode'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { DeviceSettingsOnOffTimers } from './DeviceSettingsOnOffTimers'
import { DeviceSettingsNTPServer } from './DeviceSettingsNTPServer'
import { DigitalSignageExhibitionIndex } from './__digitalSignageExhibitionIndex'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import { ComPortsSettings } from './__comPortsSettings/ComPortsSettings'
import { IpTv } from './__ipTv/IpTv'
import { ModBusSettings } from './__modBusSettings/ModBusSettings'
import helpers from '../../core/helpers'
import { CameraSettings } from './__camera/CameraSettings'
import NovastarAuthorizationSettings from './__novastarAuthorizationSettings/novastarAuthorizationSettings'
import IgnoreWebPageSecurity from './__ignoreWebPageSecurity/deviceSettings__ignoreWebPageSecurity'
import QbicAuthorizationSettings from './__qbicAuthorizationSettings/qbicAuthorizationSettings'
import { ChangeIpTvVolumeFromRemote } from './ChangeIpTvVolumeFromRemote/ChangeIpTvVolumeFromRemote'
import TimeSynchronization from './__timeSynchronization/deviceSettings__timeSynchronization'
import SleepMode from './__sleepMode/deviceSettings__sleepMode'
import { DeviceSettingsP2PDownload } from './__p2pDownload/deviceSettings__p2pDownload'
import { IpTvUseGroups } from './ipTvUseGroups/IpTvUseGroups'
import { IpTvChannelGroups } from './__ipTvChannelGroups/IpTvChannelGroups'
import { MonitorSettings } from './__monitorsSettings/MonitorSettings'
import Icon from '../../blocks.simple/icon/icon'
import { SwitchButton } from '../../atoms/SwitchButton'
import ScreenAndSleepMode from './__screenAndSleepMode/ScreenAndSleepMode'

const getTimers = (timers: any, platform: string | undefined) => {
    let data: any = {}
    const availableMultipleTimersPlatforms = [
        'sssp',
        'sssp_new',
        'tizen_7',
        'sssp_old',
        'webos',
        'webos_new',
        'webos_old',
        'android',
    ]

    if (platform && !availableMultipleTimersPlatforms.includes(platform)) {
        data.on = [timers.on[0]]
        data.off = [timers.off[0]]
    } else {
        data = timers
    }

    return data
}

const getAvailableSettingsForPlatform = (platform: any) => {
    const settingsFor = {
        pinCode: ['sssp_old', 'webos_new', 'webos_old'],
        cover: ['windows', 'linux', 'sssp_old', 'sssp_new', 'tizen_7', 'raspberry', 'colorE-Paper'],
        brightness_legacy: ['sssp_new', 'tizen_7', 'sssp_old'],
        brightness: ['windows', 'linux', 'webos_new', 'webos_old', 'android', 'raspberry'],
        remoteControlEnabled: ['sssp_new', 'tizen_7', 'sssp_old', 'webos_new', 'webos_old', 'android'],
        useWebRTC: ['android', 'windows', 'linux', 'raspberry'],
        kioskMode: ['windows', 'android', 'linux', 'raspberry', 'sssp_new', 'tizen_7', 'webos_new', 'webos_old'],
        ignoreWebPageSecurity: ['android'],
        audioOutput: ['sssp_old', 'sssp_new', 'tizen_7', 'webos_new', 'webos_old', 'raspberry', 'colorE-Paper'],
        systemNotifications: ['sssp_old', 'sssp_new', 'tizen_7', 'colorE-Paper'],
        batteryWarningIconDisplay: ['colorE-Paper'],
        syncContent: [
            'sssp_old',
            'sssp_new',
            'tizen_7',
            'webos_new',
            'webos_old',
            'android',
            'windows',
            'linux',
            'brightsign',
            'raspberry',
        ],
        onlineOfflineMode: ['sssp_old', 'sssp_new', 'tizen_7'],
        browserMode: ['windows', 'linux'],
        exhibitionModeEnabledQ: ['webos_new'],
        digitalSignageExhibitionIndex: ['webos_new'],
        megafon: ['windows', 'linux', 'android', 'raspberry'],
        logLevel: [
            'windows',
            'linux',
            'sssp_new',
            'tizen_7',
            'sssp_old',
            'webos_new',
            'webos_old',
            'android',
            'brightsign',
            'raspberry',
            'colorE-Paper',
        ],
        pictureMode: ['webos_new', 'webos_old'],
        contentStorage: ['windows'],
        chequeFilePath: ['windows'],
        webEngine: ['windows', 'linux', 'raspberry'],
        contentDownloadType: ['webos_new', 'webos_old'],
        onOffTimers: [
            'sssp_old',
            'sssp_new',
            'tizen_7',
            'webos_new',
            'webos_old',
            'android',
            'windows',
            'linux',
            'raspberry',
        ],
        onOffDisplayTimers: [
            'linux',
            'windows',
            'sssp_old',
            'sssp_new',
            'tizen_7',
            'webos_new',
            'webos_old',
            'android',
        ],
        ntpSettings: ['webos_new', 'sssp_new', 'tizen_7', 'colorE-Paper'],
        enableIPTV: [
            'android',
            'sssp_new',
            'tizen_7',
            'sssp_old',
            'webos_new',
            'webos_old',
            'windows',
            'linux',
            'raspberry',
            'brightsign',
        ],
        useChannelGroups: [
            'android',
            'sssp_new',
            'tizen_7',
            'sssp_old',
            'webos_new',
            'webos_old',
            'windows',
            'linux',
            'raspberry',
            'brightsign',
        ],
        changeIpTvVolumeFromRemote: [
            'android',
            'sssp_new',
            'tizen_7',
            'sssp_old',
            'webos_new',
            'webos_old',
            'brightsign',
        ],
        stopBroadcastWhenUpdate: ['android'],
        qbicLogin: ['android'],
        qbicPassword: ['android'],
        restartMediaStream: ['android', 'webos_new', 'windows', 'linux', 'raspberry'],
        monitorSettings: ['windows', 'linux', 'raspberry'],
    }
    const available: any = {}

    for (let key in settingsFor) {
        if (settingsFor.hasOwnProperty(key)) {
            // @ts-ignore
            available[key] = settingsFor[key].includes(platform)
        }
    }

    return available
}

const getPictureModeListForPlatform = (platform: any) => {
    const platformPictureMode = {
        webos: [
            { id: 'normal', name: translate('pictureMode_WebosNormal') },
            { id: 'vivid', name: translate('pictureMode_WebosVivid') },
            { id: 'eco', name: translate('pictureMode_WebosEco') },
            { id: 'cinema', name: translate('pictureMode_WebosCinema') },
            { id: 'game', name: translate('pictureMode_WebosGame') },
            { id: 'sports', name: translate('pictureMode_WebosSports') },
            { id: 'expert1', name: translate('pictureMode_WebosExpert1') },
            { id: 'expert2', name: translate('pictureMode_WebosExpert2') },
        ],
    }

    let availablePictureModes = []

    for (let key in platformPictureMode) {
        if (isExist(platform) && platform.includes(key)) {
            // @ts-ignore
            availablePictureModes = platformPictureMode[key]
        }
    }

    return availablePictureModes
}

class DeviceSettings extends DeviceSettingsMethods {
    static propTypes = {
        isConfirm: PropTypes.bool,
        withoutScroll: PropTypes.bool,
    }
    static defaultProps = {
        isConfirm: false,
        withoutScroll: false,
    }
    renderSidebar = () => {
        if (!this.isAvailablePlatform()) {
            return null
        }

        const p_ = this.props
        const s_ = this.state
        const isMultipleSettings = p_.type === 'group' || s_.isMultipleDevicesSettings

        return (
            <div className={styles.sidebar}>
                <Typography className={cn(styles.sidebarTitle)} type="title">
                    {translate('platform')}
                </Typography>

                <DeviceSettingsTabs
                    isMultipleSettings={isMultipleSettings}
                    platform={p_.platform!}
                    availablePlatforms={s_.availablePlatforms}
                    selectedPlatform={s_.selectedPlatform}
                    onClick={this.onSelectPlatform}
                />
                <div />
            </div>
        )
    }

    getTitle = () => {
        const s_ = this.state
        const p_ = this.props
        let title: string | {} = translate('deviceSettings')

        if (p_.type === 'group') {
            title = translate('groupSettings')
        }

        title = `${title}`

        if (s_.isMultipleDevicesSettings) {
            title = <span dangerouslySetInnerHTML={{ __html: translate('settingsForSelectedDevicesDescription') }} />
        }

        return (
            <Typography className={styles.title} type="title">
                {title}
                {p_.name ? (
                    <>
                        <span> • </span>
                        <span className={styles.deviceNameColor}>{p_.name}</span>
                    </>
                ) : (
                    ''
                )}
            </Typography>
        )
    }

    getActivePictureMode = (pictureModeList: { id: string }[]) => {
        const pictureMode = this.getSettingsValue('pictureMode')
        if (pictureMode) {
            return pictureMode
        }

        if (isNotEmptyArray(pictureModeList)) {
            return pictureModeList[0].id
        }

        return null
    }

    getActiveDownloadMode = (pictureModeList?: string[]) => {
        return this.getSettingsValue('contentDownloadType') || 'server'
    }

    setSettings = (value: any, name: string, callback?: () => void) => {
        const s_ = this.state

        if (!s_.isMultipleDevicesSettings) {
            this.setState(
                {
                    ...s_,
                    settings: {
                        ...s_.settings,
                        [name]: value,
                    },
                },
                () => {
                    if (callback) {
                        callback()
                    }
                }
            )

            return
        }

        const selectedPlatformName = s_.selectedPlatform && s_.selectedPlatform.name
        const selectedSettings = selectedPlatformName && s_.settingsList[selectedPlatformName]

        if (selectedPlatformName && selectedSettings) {
            ;((selectedSettings as unknown) as Record<string, unknown>)[name] = value

            const changedSettingsLog = { ...s_.changedSettingsLog }

            if (changedSettingsLog[selectedPlatformName]) {
                if (!changedSettingsLog[selectedPlatformName].settings.includes(name)) {
                    changedSettingsLog[selectedPlatformName].settings.push(name)
                }
            } else {
                changedSettingsLog[selectedPlatformName] = {
                    settings: [name],
                }
            }

            this.setState({
                ...s_,
                settingsList: {
                    ...s_.settingsList,
                    [selectedPlatformName]: selectedSettings,
                },
                changedSettingsLog,
            })
        }
    }

    getSettingsValue = <K extends keyof IDeviceSettings>(name: K): NonNullable<IDeviceSettings[K]> => {
        const s_ = this.state

        if (!s_.isMultipleDevicesSettings) {
            return s_.settings[name] as NonNullable<IDeviceSettings[K]>
        }

        const selectedPlatformName = s_.selectedPlatform && s_.selectedPlatform.name
        const selectedSettings = selectedPlatformName && s_.settingsList[selectedPlatformName]

        return (selectedSettings ? selectedSettings[name] : null) as NonNullable<IDeviceSettings[K]>
    }

    render() {
        const p_ = this.props
        const s_ = this.state
        let platform = this.getPlatform()

        if (platform === 'android_4') {
            platform = 'android'
        }
        const isAvailablePlatform = this.isAvailablePlatform()
        const availableSettings = getAvailableSettingsForPlatform(platform)
        const pictureModeList = getPictureModeListForPlatform(platform)
        const imageParamsModes = [
            { id: 'inside', name: translate('inside') },
            { id: 'outside', name: translate('outside') },
        ]

        return (
            <div className={cn(styles.wrapper, p_.className)}>
                {this.renderSidebar()}
                <div className={styles.content}>
                    <div className={styles.topPanel}>
                        <div className={styles.backButton} onClick={p_.onClose}>
                            <Icon type={'left_icon_menu'} size={16} />
                            <span>{translate('back')}</span>
                        </div>
                        <div className={styles.titleWrapper}>{this.getTitle()}</div>
                    </div>

                    {isAvailablePlatform && (
                        <div className={styles.containerInner}>
                            <div className={styles.deviceSettings__inner}>
                                {helpers.isAvailable({ key: 'modBus', action: 'update' }) &&
                                    (platform === 'linux' || platform === 'windows') && (
                                        <Collapse
                                            title={() => translate('modBusSettings')}
                                            className={cn(styles.collapseBorder, 'test-device-settings-block')}
                                        >
                                            <ModBusSettings
                                                modBus={this.getSettingsValue('modBus')}
                                                enabled={true}
                                                onChange={(modBus: any) => {
                                                    this.setSettings(modBus, 'modBus')
                                                }}
                                            />
                                        </Collapse>
                                    )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'raspberry' ||
                                    platform === 'colorE-Paper') && (
                                    <Collapse
                                        title={() => translate('network')}
                                        className={cn(
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        {(platform === 'windows' ||
                                            platform === 'linux' ||
                                            platform === 'sssp_new' ||
                                            platform === 'tizen_7' ||
                                            platform === 'webos_old' ||
                                            platform === 'webos_new' ||
                                            platform === 'raspberry' ||
                                            platform === 'colorE-Paper') && (
                                            <DeviceSettingsProxy
                                                settings={this.getSettingsValue('proxySettings')}
                                                platform={platform}
                                                onChange={(proxySettings) => {
                                                    this.setSettings(proxySettings, 'proxySettings')
                                                }}
                                            />
                                        )}
                                        <DeviceSettingsNTPServer
                                            title={translate('ntpServer')}
                                            platform={platform}
                                            ntpSettings={this.getSettingsValue('ntpSettings')}
                                            onChange={this.setSettings}
                                            enabled={availableSettings.ntpSettings}
                                        />
                                    </Collapse>
                                )}
                                <Collapse
                                    title={() => translate('automation')}
                                    className={cn(grid.fullWidth, styles.collapseBorder, 'test-device-settings-block')}
                                >
                                    <div className={cn(grid.row, grid.fullWidth)}>
                                        <Typography className={cn(textStyles.normal, styles.gapBottom)} type="title">
                                            {translate('rebootTimers')}
                                        </Typography>
                                        <div className={cn(grid.row, grid.fullWidth)}>
                                            <DeviceSettingsTimer
                                                timers={{
                                                    on: this.getSettingsValue('rebootTimers'),
                                                    off: [],
                                                }}
                                                type="reboot_timers"
                                                onChange={({ on }) => {
                                                    this.setSettings(on, 'rebootTimers')
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <DeviceSettingsOnOffTimers
                                        title={translate('deviceTimerSettings')}
                                        platform={platform}
                                        timers={getTimers(this.getSettingsValue('onOffTimers'), platform)}
                                        onChange={this.setSettings}
                                        enabled={availableSettings.onOffTimers}
                                        settingName={'onOffTimers'}
                                        type={'onOff'}
                                    />
                                    {platform !== 'android' && (
                                        <DeviceSettingsOnOffTimers
                                            title={translate('displayTimerSettings')}
                                            platform={platform}
                                            timers={getTimers(this.getSettingsValue('onOffDisplayTimers'), platform)}
                                            onChange={this.setSettings}
                                            enabled={availableSettings.onOffDisplayTimers}
                                            settingName={'onOffDisplayTimers'}
                                            type={'display'}
                                        />
                                    )}
                                    <DeviceSettingsBrightnessLegacy
                                        settings={this.getSettingsValue('brightnessTimers')}
                                        onChange={this.setSettings}
                                        enabled={availableSettings.brightness_legacy}
                                    />
                                    <DeviceSettingsBrightness
                                        settings={this.getSettingsValue('brightness')}
                                        onChange={this.setSettings}
                                        enabled={availableSettings.brightness}
                                    />
                                    <StopBroadcastWhenUpdate
                                        className={styles.row}
                                        enabled={availableSettings.stopBroadcastWhenUpdate}
                                        value={this.getSettingsValue('stopBroadcastOnUpdateClientApp')}
                                        onChange={this.setSettings}
                                    />
                                    {platform === 'android' && (
                                        <TimeSynchronization
                                            enabled={true}
                                            data={this.getSettingsValue('timeSynchronization')}
                                            onChange={this.setSettings}
                                        />
                                    )}
                                </Collapse>
                                {platform === 'colorE-Paper' && (
                                    <Collapse
                                        title={() => translate('screenAndSleepMode')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <ScreenAndSleepMode
                                            settings={{
                                                networkStandby: this.getSettingsValue('networkStandby'),
                                                refreshScreenAfterWakeupMS: this.getSettingsValue(
                                                    'refreshScreenAfterWakeupMS'
                                                ),
                                                autoSleepTimeAppLevelApi: this.getSettingsValue(
                                                    'autoSleepTimeAppLevelApi'
                                                ),
                                                goSleepAfterMS: this.getSettingsValue('goSleepAfterMS'),
                                                timeWakeUpEveryDay: this.getSettingsValue('timeWakeUpEveryDay'),
                                                screenRefreshTimeEveryDay: this.getSettingsValue(
                                                    'screenRefreshTimeEveryDay'
                                                ),
                                            }}
                                            onChange={this.setSettings}
                                        />
                                    </Collapse>
                                )}
                                {platform === 'android' && (
                                    <Collapse
                                        title={() => translate('sleepMode')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <SleepMode
                                            enabled={true}
                                            data={this.getSettingsValue('sleepModeSettings')}
                                            onChange={this.setSettings}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'linux' || platform === 'raspberry' || platform === 'windows') && (
                                    <Collapse
                                        title={() => translate('comPortsTechnicalParameters')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <ComPortsSettings
                                            onChange={this.setSettings}
                                            ports={this.getSettingsValue('comPorts')}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'android' ||
                                    platform === 'raspberry') && (
                                    <Collapse
                                        title={() => translate('shop')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <DeviceSettingsMegafon
                                            settings={this.getSettingsValue('megafon')}
                                            enabled={availableSettings.megafon}
                                            onChange={this.setSettings}
                                            platform={platform}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'sssp_old' ||
                                    platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'raspberry' ||
                                    platform === 'android' ||
                                    platform === 'colorE-Paper') && (
                                    <Collapse
                                        title={() => translate('deviceManagement')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        {platform !== 'android' ? (
                                            <>
                                                <DeviceSettingsPictureMode
                                                    title={translate('pictureMode')}
                                                    list={pictureModeList}
                                                    active={this.getActivePictureMode(pictureModeList)}
                                                    onChange={this.setSettings}
                                                    enabled={availableSettings.pictureMode}
                                                />
                                                <DeviceSettingsAudioOutput
                                                    value={this.getSettingsValue('audioOutput')}
                                                    enabled={availableSettings.audioOutput}
                                                    onChange={this.setSettings}
                                                    platform={platform}
                                                />
                                                <DeviceSettingsDownloadMode
                                                    title={translate('downloadMode')}
                                                    active={this.getActiveDownloadMode(pictureModeList)}
                                                    onChange={this.setSettings}
                                                    enabled={availableSettings.contentDownloadType}
                                                />
                                                {(platform === 'windows' ||
                                                    platform === 'linux' ||
                                                    platform === 'raspberry') && (
                                                    <div className={cn(grid.row, grid.fullWidth)}>
                                                        <Typography
                                                            className={cn(textStyles.normal, grid.mb_md)}
                                                            type="title"
                                                        >
                                                            {translate('positionInDeviceChain')}
                                                        </Typography>
                                                        <div className={styles.positionWrapper}>
                                                            <div className={styles.positionContent}>
                                                                <div
                                                                    className={cn(grid.row, grid.fullWidth, grid.mb_md)}
                                                                >
                                                                    <EditText
                                                                        mod={'withBorder'}
                                                                        label={translate('topIndent')}
                                                                        type="number"
                                                                        errorBorder={s_.error === 'top'}
                                                                        value={
                                                                            this.getSettingsValue('displaySettings').top
                                                                        }
                                                                        onChange={(top: string) =>
                                                                            this.setState(
                                                                                {
                                                                                    error: null,
                                                                                },
                                                                                () => {
                                                                                    this.setSettings(
                                                                                        {
                                                                                            ...this.getSettingsValue(
                                                                                                'displaySettings'
                                                                                            ),
                                                                                            top,
                                                                                        },
                                                                                        'displaySettings'
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <EditText
                                                                        mod={'withBorder'}
                                                                        label={translate('width')}
                                                                        type="number"
                                                                        errorBorder={s_.error === 'width'}
                                                                        value={
                                                                            this.getSettingsValue('displaySettings')
                                                                                .width
                                                                        }
                                                                        onChange={(width: number) =>
                                                                            this.setState(
                                                                                {
                                                                                    error: null,
                                                                                },
                                                                                () => {
                                                                                    this.setSettings(
                                                                                        {
                                                                                            ...this.getSettingsValue(
                                                                                                'displaySettings'
                                                                                            ),
                                                                                            width,
                                                                                        },
                                                                                        'displaySettings'
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className={styles.positionContent}>
                                                                <div
                                                                    className={cn(grid.row, grid.fullWidth, grid.mb_md)}
                                                                >
                                                                    <EditText
                                                                        mod={'withBorder'}
                                                                        label={translate('leftIndent')}
                                                                        type="number"
                                                                        errorBorder={s_.error === 'left'}
                                                                        value={
                                                                            this.getSettingsValue('displaySettings')
                                                                                .left
                                                                        }
                                                                        onChange={(left: string) =>
                                                                            this.setState(
                                                                                {
                                                                                    error: null,
                                                                                },
                                                                                () => {
                                                                                    this.setSettings(
                                                                                        {
                                                                                            ...this.getSettingsValue(
                                                                                                'displaySettings'
                                                                                            ),
                                                                                            left,
                                                                                        },
                                                                                        'displaySettings'
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className={cn(grid.row, grid.fullWidth)}>
                                                                    <EditText
                                                                        mod={'withBorder'}
                                                                        label={translate('height')}
                                                                        type="number"
                                                                        errorBorder={s_.error === 'height'}
                                                                        value={
                                                                            this.getSettingsValue('displaySettings')
                                                                                .height
                                                                        }
                                                                        onChange={(height: number) =>
                                                                            this.setState(
                                                                                {
                                                                                    error: null,
                                                                                },
                                                                                () => {
                                                                                    this.setSettings(
                                                                                        {
                                                                                            ...this.getSettingsValue(
                                                                                                'displaySettings'
                                                                                            ),
                                                                                            height,
                                                                                        },
                                                                                        'displaySettings'
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <DeviceSettingsCover
                                                    value={this.getSettingsValue('broadcastAutoScreenshot')}
                                                    onChange={this.setSettings}
                                                    enabled={availableSettings.cover}
                                                />
                                                {platform === 'windows' && (
                                                    <DeviceSettingsFilePath
                                                        className={styles.row}
                                                        value={this.getSettingsValue('chequeFilePath')}
                                                        onChange={this.setSettings}
                                                        editableField={'chequeFilePath'}
                                                        enabled={availableSettings.chequeFilePath}
                                                    />
                                                )}
                                                <DeviceSettingsSystemNotifications
                                                    className={styles.row}
                                                    value={this.getSettingsValue('hideSystemNotifications')}
                                                    enabled={availableSettings.systemNotifications}
                                                    onChange={this.setSettings}
                                                />
                                                <DeviceSettingsLowBatteryWarning
                                                    className={styles.row}
                                                    value={this.getSettingsValue('batteryWarningIconDisplay')}
                                                    enabled={availableSettings.batteryWarningIconDisplay}
                                                    onChange={this.setSettings}
                                                />
                                            </>
                                        ) : (
                                            <div className={cn(grid.fullWidth)}>
                                                <Typography className={cn(textStyles.normal, grid.mb_md)} type="title">
                                                    {translate('renderWindowSizes')}
                                                </Typography>
                                                <div className={styles.positionWrapper}>
                                                    <div className={cn(grid.mr_md)}>
                                                        <EditText
                                                            min={0}
                                                            mod={'withBorder'}
                                                            label={translate('width')}
                                                            type="number"
                                                            errorBorder={s_.error === 'width'}
                                                            value={this.getSettingsValue('displaySettings').width}
                                                            onChange={(width: number) =>
                                                                this.setState(
                                                                    {
                                                                        error: null,
                                                                    },
                                                                    () => {
                                                                        this.setSettings(
                                                                            {
                                                                                ...this.getSettingsValue(
                                                                                    'displaySettings'
                                                                                ),
                                                                                width,
                                                                                top: 0,
                                                                                left: 0,
                                                                            },
                                                                            'displaySettings'
                                                                        )
                                                                    }
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    <div>
                                                        <EditText
                                                            min={0}
                                                            mod={'withBorder'}
                                                            label={translate('height')}
                                                            type="number"
                                                            errorBorder={s_.error === 'height'}
                                                            value={this.getSettingsValue('displaySettings').height}
                                                            onChange={(height: number) =>
                                                                this.setState(
                                                                    {
                                                                        error: null,
                                                                    },
                                                                    () => {
                                                                        this.setSettings(
                                                                            {
                                                                                ...this.getSettingsValue(
                                                                                    'displaySettings'
                                                                                ),
                                                                                height,
                                                                                top: 0,
                                                                                left: 0,
                                                                            },
                                                                            'displaySettings'
                                                                        )
                                                                    }
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <DeviceSettingsWebRTC
                                            className={styles.row}
                                            enabled={availableSettings.useWebRTC}
                                            value={this.getSettingsValue('useWebRTC')}
                                            onChange={this.setSettings}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'windows' || platform === 'linux' || platform === 'raspberry') &&
                                    this.getSettingsValue('monitorSettings') && (
                                        <Collapse
                                            title={() => translate('monitorsSettings')}
                                            className={cn(
                                                grid.mb_md,
                                                grid.fullWidth,
                                                styles.collapseBorder,
                                                'test-device-settings-block'
                                            )}
                                        >
                                            <MonitorSettings
                                                enabled={availableSettings.monitorSettings}
                                                monitorSettings={this.getSettingsValue('monitorSettings')}
                                                onChange={this.setSettings}
                                                deviceId={p_.id!}
                                                online={p_.online!}
                                            />
                                        </Collapse>
                                    )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'android' ||
                                    platform === 'sssp_old' ||
                                    platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'raspberry') && (
                                    <Collapse
                                        title={() => translate('security')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <DeviceSettingsRemoteControl
                                            enabled={availableSettings.remoteControlEnabled}
                                            value={this.getSettingsValue('remoteControlEnabled')}
                                            onChange={this.setSettings}
                                        />
                                        <DeviceSettingsPinCode
                                            className={styles.pinCodeWrapper}
                                            value={this.getSettingsValue('pinCode')}
                                            enabled={availableSettings.pinCode}
                                            onChange={this.setSettings}
                                        />
                                        <DeviceSettingsKioskMode
                                            enabled={availableSettings.kioskMode}
                                            value={{
                                                controlsMode: this.getSettingsValue('controlsMode'),
                                                kioskMode: this.getSettingsValue('kioskMode'),
                                            }}
                                            onChange={this.setSettings}
                                        />
                                        <IgnoreWebPageSecurity
                                            className={styles.row}
                                            enabled={availableSettings.ignoreWebPageSecurity}
                                            value={this.getSettingsValue('ignoreWebPageSecurity')}
                                            onChange={this.setSettings}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'android' ||
                                    platform === 'sssp_old' ||
                                    platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'raspberry' ||
                                    platform === 'brightsign') && (
                                    <Collapse
                                        title={() => translate('content')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        {platform !== 'brightsign' && (
                                            <DeviceSettingsSyncContent
                                                enabled={availableSettings.syncContent}
                                                className={styles.syncContentWrapper}
                                                value={this.getSettingsValue('syncContent')}
                                                onChange={this.setSettings}
                                                type={p_.type!}
                                            />
                                        )}
                                        <DeviceSettingsOnlineOfflineMode
                                            enabled={availableSettings.onlineOfflineMode}
                                            className={styles.syncContentWrapper}
                                            value={this.getSettingsValue('onlineOfflineMode')}
                                            onChange={this.setSettings}
                                        />
                                        {['windows', 'raspberry', 'linux', 'android'].includes(platform) && (
                                            <div className={cn(grid.fullWidth, grid.mt_mdPlus)}>
                                                <div className={styles.switchWrapper}>
                                                    <SwitchButton
                                                        checked={!!this.getSettingsValue('speedLimit')}
                                                        onChange={() => {
                                                            this.setSettings(
                                                                !this.getSettingsValue('speedLimit') ? 64 : null,
                                                                'speedLimit'
                                                            )
                                                        }}
                                                        className={`test-settings-toggle_${
                                                            !!this.getSettingsValue('speedLimit')
                                                                ? 'enabled'
                                                                : 'disabled'
                                                        }`}
                                                    />
                                                    <div className={cn(styles.switchCaption)}>
                                                        <Typography className={cn(textStyles.normal)} type="title">
                                                            {translate('speedLimitDownloadingContent')}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div
                                                    className={cn(styles.deviceSettings__inputWrapper_type_speedLimit, {
                                                        [item.disableWrapper]: !this.getSettingsValue('speedLimit'),
                                                    })}
                                                >
                                                    <EditText
                                                        mod={'withBorder'}
                                                        type="number"
                                                        value={this.getSettingsValue('speedLimit') || ''}
                                                        onChange={(speedLimit: number) =>
                                                            this.setSettings(speedLimit, 'speedLimit')
                                                        }
                                                        onBlur={(speedLimit: number) => {
                                                            if (this.getSettingsValue('speedLimit')) {
                                                                this.setSettings(
                                                                    speedLimit >= 64 ? speedLimit : 64,
                                                                    'speedLimit'
                                                                )
                                                            }
                                                        }}
                                                    />
                                                    <div className={styles.hint}>
                                                        {translate('speedLimitDescription')}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <DeviceSettingsContentStorage
                                            className={styles.row}
                                            value={this.getSettingsValue('contentStoragePath')}
                                            onChange={this.setSettings}
                                            enabled={availableSettings.contentStorage}
                                        />
                                        {(platform === 'windows' || platform === 'linux' || platform === 'raspberry') &&
                                            this.getDeviceSettingsFromCompany() && (
                                                <div className={cn(grid.row, grid.fullWidth, grid.mt_mdPlus)}>
                                                    <Typography
                                                        className={cn(textStyles.normal, grid.mb_md)}
                                                        type="title"
                                                    >
                                                        {translate('downloadFiles')}
                                                    </Typography>
                                                    <div className={cn(grid.row, grid.fullWidth)}>
                                                        {this.getDeviceSettingsFromCompany()?.map((type: string) => (
                                                            <div key={`content_download_${type}`}>
                                                                <Radio
                                                                    className={
                                                                        styles.deviceSettings__input_type_contentDownloadType
                                                                    }
                                                                    onClick={() =>
                                                                        this.setSettings(type, 'contentDownloadType')
                                                                    }
                                                                    selected={
                                                                        this.getSettingsValue('contentDownloadType') ===
                                                                        type
                                                                    }
                                                                    label={translate(type)}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {s_.settings.contentDownloadType === 'netDisk' && (
                                                        <div
                                                            className={
                                                                styles.deviceSettings__inputWrapper_type_netDiskAddress
                                                            }
                                                        >
                                                            <EditText
                                                                mod={'withBorder'}
                                                                label={translate('netDiskAddress')}
                                                                value={this.getSettingsValue('netDiskAddress')}
                                                                placeholder={'\\\\127.0.0.1\\example'}
                                                                onChange={(netDiskAddress: string) => {
                                                                    this.setSettings(netDiskAddress, 'netDiskAddress')
                                                                }}
                                                            />
                                                            {p_.type !== 'group' && (
                                                                <div className={grid.mt_mdPlus}>
                                                                    <Typography
                                                                        className={cn(textStyles.normal, grid.mb_md)}
                                                                        type="title"
                                                                    >
                                                                        {translate('netDiskDefaultMaster')}
                                                                    </Typography>
                                                                    <div className={cn(grid.row, grid.fullWidth)}>
                                                                        <Radio
                                                                            className={cn(grid.mr_md)}
                                                                            onClick={() =>
                                                                                this.setSettings(
                                                                                    true,
                                                                                    'netDiskDefaultMaster'
                                                                                )
                                                                            }
                                                                            selected={this.getSettingsValue(
                                                                                'netDiskDefaultMaster'
                                                                            )}
                                                                            label={translate('yes')}
                                                                        />
                                                                        <Radio
                                                                            onClick={() =>
                                                                                this.setSettings(
                                                                                    false,
                                                                                    'netDiskDefaultMaster'
                                                                                )
                                                                            }
                                                                            selected={
                                                                                !this.getSettingsValue(
                                                                                    'netDiskDefaultMaster'
                                                                                )
                                                                            }
                                                                            label={translate('no')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        {(platform === 'windows' ||
                                            platform === 'linux' ||
                                            platform === 'raspberry') && (
                                            <div className={cn(grid.row, grid.fullWidth, grid.mt_mdPlus)}>
                                                <Typography className={cn(textStyles.normal, grid.mb_md)} type="title">
                                                    {translate('videoPlayerSettings')}
                                                </Typography>
                                                <div className={cn(grid.row, grid.fullWidth)}>
                                                    <DeviceSettingsVideoPlayer
                                                        settings={this.getSettingsValue('videoPlayerSettings')}
                                                        onChange={(videoPlayerSettings) => {
                                                            this.setSettings(videoPlayerSettings, 'videoPlayerSettings')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <DeviceSettingsWebEngine
                                            settings={this.getSettingsValue('webEngineSettings')}
                                            onChange={this.setSettings}
                                            enabled={availableSettings.webEngine}
                                        />
                                    </Collapse>
                                )}
                                {platform === 'android' && (
                                    <Collapse
                                        title={() => translate('p2pDownload')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <DeviceSettingsP2PDownload
                                            className={styles.row}
                                            enabled={availableSettings.remoteControlEnabled}
                                            data={this.getSettingsValue('p2pDownload')}
                                            group={p_}
                                            mode={p_.type === 'group' ? 'group' : 'device'}
                                            onChange={this.setSettings}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'android' ||
                                    platform === 'sssp_old' ||
                                    platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'raspberry' ||
                                    platform === 'brightsign') && (
                                    <Collapse
                                        title={() => translate('ipTv')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <IpTv
                                            enableIPTV={this.getSettingsValue('enableIPTV')}
                                            onChange={(value) => this.setSettings(value, 'enableIPTV')}
                                            enabled={availableSettings.enableIPTV}
                                        />
                                        <ChangeIpTvVolumeFromRemote
                                            changeIpTvVolumeFromRemote={this.getSettingsValue(
                                                'changeIpTvVolumeFromRemote'
                                            )}
                                            onChange={(value) => this.setSettings(value, 'changeIpTvVolumeFromRemote')}
                                            enabled={availableSettings.changeIpTvVolumeFromRemote}
                                            ipTvEnabled={this.getSettingsValue('enableIPTV')}
                                        />
                                        {this.getSettingsValue('enableIPTV') && (
                                            <>
                                                <IpTvUseGroups
                                                    useChannelGroups={this.getSettingsValue('useChannelGroups')}
                                                    onChange={(value) => this.setSettings(value, 'useChannelGroups')}
                                                    enabled={availableSettings.useChannelGroups}
                                                />
                                                {this.getSettingsValue('useChannelGroups') && (
                                                    <IpTvChannelGroups
                                                        channelGroupId={this.getSettingsValue('channelGroupId')}
                                                        onChange={(value) => this.setSettings(value, 'channelGroupId')}
                                                        enabled={true}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </Collapse>
                                )}
                                {(platform === 'android' ||
                                    platform === 'webos_new' ||
                                    platform === 'windows' ||
                                    platform === 'linux' ||
                                    platform === 'raspberry') && (
                                    <Collapse
                                        title={() => translate('videoPlayer')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        {platform === 'android' && (
                                            <div className={cn(grid.row, grid.fullWidth)}>
                                                <div className={cn(grid.row, grid.fullWidth)}>
                                                    <DeviceSettingsAndroidVideoPlayer
                                                        settings={this.getSettingsValue('androidVideoPlayerSettings')}
                                                        onChange={(androidVideoPlayerSettings) => {
                                                            this.setSettings(
                                                                androidVideoPlayerSettings,
                                                                'androidVideoPlayerSettings'
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className={cn(grid.row, grid.fullWidth)}>
                                            <RestartMediaStream
                                                className={styles.row}
                                                enabled={availableSettings.restartMediaStream}
                                                value={this.getSettingsValue('restartMediaStream')}
                                                onChange={this.setSettings}
                                            />
                                        </div>
                                    </Collapse>
                                )}
                                {platform === 'android' && (
                                    <Collapse
                                        title={() => translate('audioPlayer')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <div>
                                            <DeviceSettingsAudioPlayer
                                                settings={this.getSettingsValue('audioPlayerSettings')}
                                                onChange={(audioPlayerSettings) => {
                                                    this.setSettings(audioPlayerSettings, 'audioPlayerSettings')
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                )}
                                {(platform === 'sssp_new' ||
                                    platform === 'tizen_7' ||
                                    platform === 'sssp_old' ||
                                    platform === 'brightsign' ||
                                    platform === 'android' ||
                                    platform === 'webos_old' ||
                                    platform === 'webos_new' ||
                                    platform === 'colorE-Paper') && (
                                    <Collapse
                                        title={() => translate('imageResizing')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <div className={styles.switchWrapper}>
                                            <SwitchButton
                                                checked={this.getSettingsValue('resizeImageQ')}
                                                onChange={() => {
                                                    this.setSettings(
                                                        !this.getSettingsValue('resizeImageQ'),
                                                        'resizeImageQ'
                                                    )
                                                }}
                                                className={`test-settings-toggle_${
                                                    this.getSettingsValue('resizeImageQ') ? 'enabled' : 'disabled'
                                                }`}
                                            />
                                            <div className={cn(styles.switchCaption)}>
                                                <Typography type="title">{translate('resizeAnImage')}</Typography>
                                            </div>
                                        </div>
                                        <div className={styles.switchWrapper}>
                                            <SwitchButton
                                                className={`test-settings-toggle_${
                                                    this.getSettingsValue('resizeImageParams') &&
                                                    this.getSettingsValue('resizeImageParams').preserveAspectRatioQ
                                                        ? 'enabled'
                                                        : 'disabled'
                                                }`}
                                                disabled={!this.getSettingsValue('resizeImageQ')}
                                                checked={
                                                    this.getSettingsValue('resizeImageParams') &&
                                                    this.getSettingsValue('resizeImageParams').preserveAspectRatioQ
                                                }
                                                onChange={() => {
                                                    if (
                                                        !(
                                                            this.getSettingsValue('resizeImageParams') &&
                                                            this.getSettingsValue('resizeImageParams')
                                                                .preserveAspectRatioQ
                                                        )
                                                    ) {
                                                        this.setSettings(
                                                            {
                                                                ...this.getSettingsValue('resizeImageParams'),
                                                                preserveAspectRatioQ: true,
                                                                mode: 'inside',
                                                                backgroundColor: '#000000',
                                                            },
                                                            'resizeImageParams'
                                                        )

                                                        return
                                                    }

                                                    this.setSettings(
                                                        {
                                                            preserveAspectRatioQ: false,
                                                        },
                                                        'resizeImageParams'
                                                    )
                                                }}
                                            />
                                            <div className={cn(styles.switchCaption)}>
                                                <Typography type="title">{translate('maintainProportions')}</Typography>
                                            </div>
                                        </div>
                                        <div className={cn(grid.mb_md)}>
                                            <Typography className={cn(textStyles.normal, grid.mb_md)} type="title">
                                                {translate('fitCut')}
                                            </Typography>
                                            <div className={styles.dropdownWrapper}>
                                                <Dropdown
                                                    disabled={
                                                        !(
                                                            this.getSettingsValue('resizeImageQ') &&
                                                            this.getSettingsValue('resizeImageParams') &&
                                                            this.getSettingsValue('resizeImageParams')
                                                                .preserveAspectRatioQ
                                                        )
                                                    }
                                                    placeholder={translate('inside')}
                                                    value={
                                                        this.getSettingsValue('resizeImageParams') &&
                                                        this.getSettingsValue('resizeImageParams').preserveAspectRatioQ
                                                            ? this.getSettingsValue('resizeImageParams').mode
                                                            : this.getSettingsValue('resizeImageParams') &&
                                                              this.getSettingsValue('resizeImageParams').mode &&
                                                              this.getSettingsValue('resizeImageParams').mode
                                                    }
                                                    options={imageParamsModes}
                                                    onChange={(e) =>
                                                        this.getSettingsValue('resizeImageParams').mode !== 'inside'
                                                            ? this.setSettings(
                                                                  {
                                                                      ...this.getSettingsValue('resizeImageParams'),
                                                                      mode: e.id,
                                                                  },
                                                                  'resizeImageParams'
                                                              )
                                                            : this.setSettings(
                                                                  {
                                                                      preserveAspectRatioQ: true,
                                                                      mode: e.id,
                                                                  },
                                                                  'resizeImageParams'
                                                              )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className={cn(grid.mb_md)}>
                                            <Typography className={cn(textStyles.normal, grid.mb_md)} type="title">
                                                {translate('resizingBackgroundColor')}
                                            </Typography>
                                            <div className={cn(grid.row, grid.fullWidth)}>
                                                <Colorpicker
                                                    disableAlpha
                                                    disabled={
                                                        !(
                                                            this.getSettingsValue('resizeImageQ') &&
                                                            this.getSettingsValue('resizeImageParams') &&
                                                            this.getSettingsValue('resizeImageParams').mode === 'inside'
                                                        )
                                                    }
                                                    style={{ borderRight: 'none' }}
                                                    onChange={(value) =>
                                                        this.setSettings(
                                                            {
                                                                ...this.getSettingsValue('resizeImageParams'),
                                                                backgroundColor: value,
                                                            },
                                                            'resizeImageParams'
                                                        )
                                                    }
                                                    color={
                                                        (this.getSettingsValue('resizeImageParams') &&
                                                            this.getSettingsValue('resizeImageParams').mode ===
                                                                'inside' &&
                                                            this.getSettingsValue('resizeImageParams')
                                                                .backgroundColor) as string
                                                    }
                                                    side={p_.small ? 'right' : false}
                                                    title={translate('generalBackground')}
                                                />
                                            </div>
                                        </div>
                                    </Collapse>
                                )}
                                {platform === 'webos_new' && (
                                    <Collapse
                                        title={() => translate('exhibitionMode')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <DeviceSettingsExhibitionMode
                                            enabled={availableSettings.exhibitionModeEnabledQ}
                                            className={styles.exhibitionModeContentWrapper}
                                            value={this.getSettingsValue('exhibitionModeEnabledQ')}
                                            onChange={this.setSettings}
                                            type={p_.type!}
                                        />
                                        <DigitalSignageExhibitionIndex
                                            title={translate('digitalSignageExhibitionIndex')}
                                            platform={platform}
                                            digitalSignageExhibitionIndex={this.getSettingsValue(
                                                'digitalSignageExhibitionIndex'
                                            )}
                                            onChange={this.setSettings}
                                            enabled={availableSettings.digitalSignageExhibitionIndex}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'linux' || platform === 'windows') && (
                                    <Collapse
                                        title={() => translate('browser')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <DeviceSettingsBrowserMode
                                            enabled={availableSettings.browserMode}
                                            browserSettings={this.getSettingsValue('browserSettings')}
                                            onChange={this.setSettings}
                                            platform={platform}
                                        />
                                    </Collapse>
                                )}
                                {(platform === 'linux' || platform === 'windows' || platform === 'raspberry') && (
                                    <Collapse
                                        title={() => translate('camera')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <CameraSettings
                                            cameras={this.getSettingsValue('cameras')}
                                            onChange={(cameras: any) => {
                                                this.setSettings(cameras, 'cameras')
                                            }}
                                            enabled={true}
                                        />
                                    </Collapse>
                                )}
                                {platform === 'android' && (
                                    <Collapse
                                        title={() => translate('novastarSupportDevices')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <NovastarAuthorizationSettings
                                            settings={this.getSettingsValue('novastar')}
                                            onChange={(novastar) => {
                                                this.setSettings(novastar, 'novastar')
                                            }}
                                        />
                                    </Collapse>
                                )}
                                {platform === 'android' && (
                                    <Collapse
                                        title={() => translate('qbicAuthorizationSettings')}
                                        className={cn(
                                            grid.mb_md,
                                            grid.fullWidth,
                                            styles.collapseBorder,
                                            'test-device-settings-block'
                                        )}
                                    >
                                        <QbicAuthorizationSettings
                                            settings={{
                                                qbicLogin: this.getSettingsValue('qbicLogin'),
                                                qbicPassword: this.getSettingsValue('qbicPassword'),
                                            }}
                                            onChange={(qbicSettings) => {
                                                this.setSettings(qbicSettings.value, qbicSettings.field)
                                            }}
                                        />
                                    </Collapse>
                                )}
                                <Collapse
                                    title={() => translate('development')}
                                    className={cn(
                                        grid.mb_md,
                                        grid.fullWidth,
                                        styles.collapseBorder,
                                        'test-device-settings-block'
                                    )}
                                >
                                    <DeviceSettingsLogLevel
                                        value={{
                                            logLevel: this.getSettingsValue('logLevel'),
                                            writeSystemLog: this.getSettingsValue('writeSystemLog'),
                                        }}
                                        enabled={availableSettings.logLevel}
                                        onChange={this.setSettings}
                                        platform={platform}
                                    />
                                </Collapse>
                            </div>
                        </div>
                    )}
                    {isAvailablePlatform && (
                        <div className={styles.buttons}>
                            {!!(s_.isMultipleDevicesSettings && Object.keys(s_.changedSettingsLog).length) && (
                                <div className={cn(grid.row, grid.w100)}>
                                    {p_.type === 'group' && (
                                        <Checkbox
                                            wrapperClassName={cn(grid.mt_md)}
                                            checked={s_.applyOnlyChangedSettings}
                                            label={translate('updateOnlySelectedSettings')}
                                            onClick={(checked: boolean) =>
                                                this.setState({
                                                    applyOnlyChangedSettings: checked,
                                                })
                                            }
                                        />
                                    )}
                                </div>
                            )}
                            {isAvailablePlatform && (
                                <div className={cn(grid.row, grid.w100)}>
                                    {p_.type === 'group' && (
                                        <Checkbox
                                            wrapperClassName={cn(grid.mt_md)}
                                            checked={s_.applyRecursively}
                                            label={this.getApplyRecursivelyLabel()}
                                            onClick={(checked: boolean) =>
                                                this.setState({
                                                    applyRecursively: checked,
                                                })
                                            }
                                        />
                                    )}
                                </div>
                            )}
                            {!s_.isMultipleDevicesSettings && (
                                <div className={cn(grid.row, grid.justify)}>
                                    <Button
                                        className={cn(grid.mt_md, grid.mr_md)}
                                        disabled={p_.settings && Object.keys(p_.settings).length === 0}
                                        onClick={() =>
                                            this.getSettings(p_.settings, p_.platformId || s_.selectedPlatform!.id)
                                        }
                                    >
                                        {translate('restoreSettings')}
                                    </Button>
                                </div>
                            )}
                            <Button
                                className={cn(grid.mt_md, grid.mr_md)}
                                mod={'fillBrand'}
                                onClick={
                                    p_.isConfirm
                                        ? () =>
                                              this.setState({
                                                  modalState: true,
                                              })
                                        : this.saveSettings
                                }
                            >
                                {translate('editDisplay')}
                            </Button>
                        </div>
                    )}
                    {!isAvailablePlatform && <DeviceSettingsNoSettings />}
                </div>
                <DeviceSettingsAccept
                    open={s_.modalState}
                    onCancel={this.onCloseAcceptModal}
                    onAccept={this.saveSettings}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: { user: { company: { settings: any } } }) => ({
    deviceSettings: state.user.company.settings,
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        emitError: (err: string) => dispatch(emitError(err)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSettings)
